import axios, { AxiosInstance } from 'axios';
import ApiUrl from './config';

const EXPORT_TIMEOUT_MS = 10 * 60 * 1000;

async function readBlobError(blob: Blob): Promise<string> {
  const text = await blob.text();
  if (!text) return 'Пустой ответ сервера';

  try {
    const json = JSON.parse(text) as { title?: string; detail?: string; message?: string };
    return json.detail || json.title || json.message || text;
  } catch {
    return text;
  }
}

async function ensurePdfBlob(blob: Blob): Promise<Blob> {
  if (blob.size < 100) {
    throw new Error(await readBlobError(blob));
  }

  const header = new Uint8Array(await blob.slice(0, 5).arrayBuffer());
  const isPdf =
    header[0] === 0x25 &&
    header[1] === 0x50 &&
    header[2] === 0x44 &&
    header[3] === 0x46;
  if (!isPdf) {
    throw new Error(await readBlobError(blob));
  }

  return new Blob([blob], { type: 'application/pdf' });
}

export class TournamentExportClient {
  private http: AxiosInstance;
  private baseUrl: string;

  constructor(baseUrl: string = ApiUrl, instance?: AxiosInstance) {
    this.http = instance ?? axios;
    this.baseUrl = baseUrl ?? '';
  }

  private url(path: string) {
    return `${this.baseUrl}${path}`;
  }

  async downloadAllProtocolsPdf(tournamentId: number): Promise<void> {
    const response = await this.http.get(this.url('/api/Tournament/ExportAllProtocolsPdf'), {
      params: { tournamentId },
      responseType: 'blob',
      timeout: EXPORT_TIMEOUT_MS,
    });

    const blob = await ensurePdfBlob(response.data);
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
    window.setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
  }
}

export const tournamentExportClient = new TournamentExportClient(ApiUrl, axios);
